var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.50008C2.32906 7.50008 2.96494 7.76347 3.43378 8.23231C3.90262 8.70115 4.16602 9.33704 4.16602 10.0001C4.16602 10.6631 3.90262 11.299 3.43378 11.7678C2.96494 12.2367 2.32906 12.5001 1.66602 12.5001V14.1667C1.66602 14.6088 1.84161 15.0327 2.15417 15.3453C2.46673 15.6578 2.89065 15.8334 3.33268 15.8334H16.666C17.108 15.8334 17.532 15.6578 17.8445 15.3453C18.1571 15.0327 18.3327 14.6088 18.3327 14.1667V12.5001C17.6696 12.5001 17.0338 12.2367 16.5649 11.7678C16.0961 11.299 15.8327 10.6631 15.8327 10.0001C15.8327 9.33704 16.0961 8.70115 16.5649 8.23231C17.0338 7.76347 17.6696 7.50008 18.3327 7.50008V5.83341C18.3327 5.39139 18.1571 4.96746 17.8445 4.6549C17.532 4.34234 17.108 4.16675 16.666 4.16675H3.33268C2.89065 4.16675 2.46673 4.34234 2.15417 4.6549C1.84161 4.96746 1.66602 5.39139 1.66602 5.83341V7.50008Z",
    stroke: "#1A2E1A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 4.16675V5.83341",
    stroke: "#1A2E1A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 14.1667V15.8334",
    stroke: "#1A2E1A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 9.16675V10.8334",
    stroke: "#1A2E1A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.aa6b37cca99689aeedf6b87825b1aea1.svg";
export { ForwardRef as ReactComponent };